import { render } from "./CardBottomInfo.vue?vue&type=template&id=74c8d800"
import script from "./CardBottomInfo.vue?vue&type=script&lang=js"
export * from "./CardBottomInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__